import { useEffect, useState, useRef } from "react"
import { track } from "utilities/tracking"

export default function JotFormEmbed({ formURL, autoFocus, heightOffset = 30, initialHeight = 540, formID, ...rest }) {
  const iframeRef = useRef(null)
  const [componentStyles, setComponentStyles] = useState({
    height: initialHeight,
    overflow: "hidden",
    border: 0,
    width: "100%",
  })

  const [hasMounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    const handleMessages = (content) => {
      if (!content) {
        return
      }

      // Check if submission is completed.
      if (typeof content.data === "object" && content.data.action === "submission-completed") {
        console.debug(content.data)
        track({ event: "form_submit" })
        return
      }

      // From now on we only handle style related messages
      if (typeof content.data !== "string") {
        return
      }
      const [method, value, targetForm] = content.data.split(":")
      // eslint-disable-next-line
      if (formID && targetForm && targetForm !== formID) {
        // If you want to use multiple form via embed you need to use formID
        return
      }

      switch (method) {
        case "scrollIntoView" && autoFocus:
          if (typeof iframeRef.current.scrollIntoView === "function") {
            iframeRef.current.scrollIntoView()
          }
          break
        case "setHeight":
          setComponentStyles({ ...componentStyles, height: parseInt(value, 10) + heightOffset })
          break
        case "setMinHeight":
          setComponentStyles({ ...componentStyles, minHeight: parseInt(value, 10) + heightOffset })
          break
        case "reloadPage":
          try {
            iframeRef.current.contentWindow.location.reload()
          } catch (e) {
            console.debug("failed to reload", e)
          }
          break
        default:
          break
      }
    }

    window.addEventListener("message", handleMessages, true) // Capture

    return () => {
      window.removeEventListener("message", handleMessages, true)
    }
  }, [autoFocus, componentStyles, formID, heightOffset])

  return hasMounted ? (
    <iframe
      ref={iframeRef}
      src={formURL}
      title="JotForm Form"
      style={componentStyles}
      allowtransparency="true"
      allowFullScreen
      allow="geolocation; microphone; camera"
      {...rest}
    />
  ) : null
}
